// Import the global requirements
import React, { useEffect, useState, useMemo } from 'react'
import { createRoot } from 'react-dom/client'
import { addMilliseconds, isWithinInterval } from 'date-fns'
import { CACHED_TOKEN_KEY } from "@wantable/Config"
import { checkSessionStatus, checkIfLoggedIn } from "@wantable/Shared"

// Import the component from the package
import { Header } from '@wantable/Header'

// declare the id of the element to be used where the component will be rendered
const rootEl = document.getElementById('headless-header')

const root = createRoot(rootEl)
const countItems = () => {
  return window.__CART__.items.reduce(
    (previousValue, item) => previousValue + Number(item.quantity),
    0
  )
}

function onValueUpdate(wishlistAmount) {
  // Some arbitrary logic you want to execute on callback
  if (wishlistAmount !== undefined) {
    localStorage.setItem("_wishlistAmount", wishlistAmount)
    window.dispatchEvent(new Event("wishlistUpdate"));
    return wishlistAmount
  }
}

// I don't really like this, but couldn't find a better way to handle
// this with the current implementation
Object.defineProperties(window, {
    _wishlistAmount: {
        value: 0,
        writable: true
    },
    wishlistAmount: {
        get: function() {
            return localStorage.getItem("_wishlistAmount");
        },
        set: function(val) {
            this._wishlistAmount = val;
            onValueUpdate(this._wishlistAmount);
        }
    }
});

const Wrapper = () => {
  const [loggedIn, setLoggedIn] = useState(false)
  const [cartItemsCount, setCartItemsCount] = useState(countItems())
  const [wishListCount, setWishListCount] = useState(localStorage.getItem('_wishlistAmount'))

  const onAfterLogin = () => {
    const tokenValue = JSON.parse(
      localStorage.getItem(CACHED_TOKEN_KEY)
    )

    let signInRedirect = window.location.href.replace(window.location.origin, '');

    if (tokenValue) {
      if (tokenValue && tokenValue.shopifyToken) {
        window.location.href = '/account/login/multipass/' +
                                tokenValue.shopifyToken.token +
                                '?return_to=' +
                                signInRedirect;
      }
    }
  }

  useEffect(() => {
    setLoggedIn(checkIfLoggedIn())
  }, [])

  window.addEventListener('token stored', () => {
    setLoggedIn(checkIfLoggedIn())
  })

  window.addEventListener('token removed', () => {
    setLoggedIn(checkIfLoggedIn())
    window.location.href = '/account/logout'
  })

  window.addEventListener('wantable cart updated', () => {
    setCartItemsCount(countItems())
  })

  window.addEventListener("wishlistUpdate", () => {
    onValueUpdate()
    setWishListCount(localStorage.getItem('_wishlistAmount'))
  })

  return (
    <Header
      onAfterLogin={onAfterLogin}
      isLoggedIn={loggedIn}
      cartItemsAmount={cartItemsCount}
      wishlistItemsAmount={wishListCount}
      onLogout={() => {}}
      openedModal="true"
      openModal="true"
    />
  )
}

rootEl && root.render(<Wrapper />)
